export const TOWERS_ARRAY = [
  'neutral',
  'fire',
  'lightning',
  'ice'
];

// Priority order: Neutral → Fire → Lightning → Ice
export const TOWER_TYPES = {
  NEUTRAL: 'neutral',
  FIRE: 'fire',
  LIGHTNING: 'lightning',
  ICE: 'ice',
};

export const TOWER_TYPE_LABELS = {
  [TOWER_TYPES.NEUTRAL]: 'Neutra',
  [TOWER_TYPES.FIRE]: 'Fogo',
  [TOWER_TYPES.LIGHTNING]: 'Raio',
  [TOWER_TYPES.ICE]: 'Gelo',
};

export const TOWER_TYPE_COLORS = {
  [TOWER_TYPES.NEUTRAL]: '#a0a0a0',
  [TOWER_TYPES.FIRE]: '#ff6b35',
  [TOWER_TYPES.LIGHTNING]: '#f7c948',
  [TOWER_TYPES.ICE]: '#4fc3f7',
};

export const TOWER_TYPE_GLOW = {
  [TOWER_TYPES.NEUTRAL]: '#a0a0a0',
  [TOWER_TYPES.FIRE]: '#ff4500',
  [TOWER_TYPES.LIGHTNING]: '#ffe000',
  [TOWER_TYPES.ICE]: '#00cfff',
};

const PRIORITY = {
  [TOWER_TYPES.NEUTRAL]: 1,
  [TOWER_TYPES.FIRE]: 2,
  [TOWER_TYPES.LIGHTNING]: 3,
  [TOWER_TYPES.ICE]: 4,
};

export const TOWERS = [
  { id: 1, label: 'Torre 1', sector: '1' },
  { id: 2, label: 'Torre 2', sector: 'A' },
  { id: 3, label: 'Torre 3', sector: 'B' },
  { id: 4, label: 'Torre 4', sector: 'C' },
  { id: 5, label: 'Torre 5', sector: 'D' },
  { id: 6, label: 'Torre 6', sector: 'D' },
];

export function useRotationOrder(towerTypes) {
  // towerTypes: { [towerId]: TOWER_TYPES value }
  const sorted = [...TOWERS]
    .filter((t) => towerTypes[t.id])
    .sort((a, b) => {
      const pa = PRIORITY[towerTypes[a.id]] ?? 99;
      const pb = PRIORITY[towerTypes[b.id]] ?? 99;
      if (pa !== pb) return pa - pb;
      return a.id - b.id;
    });

  return sorted;
}

